import { useMemo } from 'react';
import { getAddressFieldConditionalComponents } from '../../../document/components/AddressField.tsx';
import { ArticleNumberFieldConditionalComponents } from '../../../document/components/ArticleNumberField.tsx';
import { getContactFieldConditionalComponents } from '../../../document/components/ContactField.tsx';
import {
    getCustomerFieldConditionalComponents,
    getCustomerFieldGroupConditionalComponents,
} from '../../../document/components/CustomerField.tsx';
import { FrameworkContractNumberFieldConditionalComponents } from '../../../document/components/FrameworkContractNumberField.tsx';
import { QuoteNumberFieldConditionalComponents } from '../../../document/components/QuoteNumberField.tsx';
import { DocumentType } from '../../../document/constants.ts';
import DocumentAssistance from '../../../document/pages/Assistance';
import {
    ASSISTANCE_PATH,
    ASSISTANCE_TAB_PATH,
    CHANNEL_FINISHED_PATH,
    CHANNEL_PATH,
    CHANNEL_TESTING_PATH,
    OVERVIEW_FINISHED_PATH,
    OVERVIEW_PATH,
    OVERVIEW_TESTING_PATH,
} from '../constants.ts';
import {
    GET_CHANNELS_OVERVIEW_DATA,
    GET_ASSISTANCE_OVERVIEW_DATA,
    GET_NEXT_ASSISTANCE_RECORD,
    GET_RELATED_DOCUMENT,
    ORDER_EXTRACT_TEXT,
    RE_UPLOAD_FILE,
    REOPEN_FOR_ASSISTANCE,
    RETRY_STEP,
    SEND_TO_LABELING,
} from '../queries.ts';

export const documentTypeName = 'order';

const OrderAssistance = (props) => {
    const documentConfiguration = useMemo(
        () => ({
            documentType: DocumentType.Order,
            documentTypeName: 'order',
            supportsAgenticExtraction: true,
            GET_ASSISTANCE_OVERVIEW_DATA: GET_ASSISTANCE_OVERVIEW_DATA,
            GET_CHANNELS_OVERVIEW_DATA: GET_CHANNELS_OVERVIEW_DATA,
            GET_NEXT_ASSISTANCE_RECORD: GET_NEXT_ASSISTANCE_RECORD,
            GET_RELATED_DOCUMENT: GET_RELATED_DOCUMENT,
            RETRY_STEP: RETRY_STEP,
            REOPEN_FOR_ASSISTANCE: REOPEN_FOR_ASSISTANCE,
            ASSISTANCE_PATH: ASSISTANCE_PATH,
            ASSISTANCE_TAB_PATH: ASSISTANCE_TAB_PATH,
            OVERVIEW_PATH: OVERVIEW_PATH,
            OVERVIEW_FINISHED_PATH: OVERVIEW_FINISHED_PATH,
            OVERVIEW_TESTING_PATH: OVERVIEW_TESTING_PATH,
            CHANNEL_PATH: CHANNEL_PATH,
            CHANNEL_FINISHED_PATH: CHANNEL_FINISHED_PATH,
            CHANNEL_TESTING_PATH: CHANNEL_TESTING_PATH,
            RE_UPLOAD_FILE: RE_UPLOAD_FILE,
            EXTRACT_TEXT: ORDER_EXTRACT_TEXT,
            SEND_TO_LABELING: SEND_TO_LABELING,
            components: {
                Field: [
                    ...getCustomerFieldConditionalComponents('customer'),
                    ...getContactFieldConditionalComponents('customer_contact'),
                    ...getAddressFieldConditionalComponents('delivery_address'),
                    ...getAddressFieldConditionalComponents('invoice_address'),
                    ...FrameworkContractNumberFieldConditionalComponents,
                    ...QuoteNumberFieldConditionalComponents,
                    ...ArticleNumberFieldConditionalComponents,
                ],
                HeaderDataFieldGroup: [...getCustomerFieldGroupConditionalComponents('customer')],
            },
            hasSelfServiceFormSupport: true,
        }),
        []
    );

    return <DocumentAssistance documentConfiguration={documentConfiguration} {...props} />;
};

export default OrderAssistance;
